import UnFrontChart from './UnFrontChart.vue';

export * from './constants';

export default UnFrontChart;
